function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "187.03 149.42 204.65 339.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingerprint--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.58,
    y: 149.97,
    width: 125.64,
    height: 138.82,
    rx: 4.24,
    style: {
      fill: "#10A7D0",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 196.25,
    x2: 190.11,
    y2: 196.25,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 211.67,
    x2: 190.11,
    y2: 211.67,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 227.09,
    x2: 190.11,
    y2: 227.09,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 242.51,
    x2: 190.11,
    y2: 242.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 257.93,
    x2: 190.11,
    y2: 257.93,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 273.36,
    x2: 190.11,
    y2: 273.36,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 180.82,
    x2: 190.11,
    y2: 180.82,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 310.69,
    y1: 165.4,
    x2: 190.11,
    y2: 165.4,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.88,
    y1: 286.31,
    x2: 281.88,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.14,
    y1: 286.31,
    x2: 266.14,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.4,
    y1: 286.31,
    x2: 250.4,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 234.66,
    y1: 286.31,
    x2: 234.66,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.92,
    y1: 286.31,
    x2: 218.92,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 203.19,
    y1: 286.31,
    x2: 203.19,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 297.62,
    y1: 286.31,
    x2: 297.62,
    y2: 152.44,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M246,261.67a148.87,148.87,0,0,1,5.51-20.51c.47-1.35,1-2.71,1.58-4.16,1.37-3.5,4.18-10.65,3.12-12.78a1.41,1.41,0,0,0-1.17-.81.39.39,0,0,0-.29.11c-3.12,2.55-5.13,9.62-6.59,14.78l-.49,1.74a133.29,133.29,0,0,0-4.1,21.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.63,262a143.74,143.74,0,0,1,5.23-19.31c.44-1.29,1-2.64,1.53-4.06,2.19-5.57,4.91-12.47,2.95-16.42a6,6,0,0,0-5.26-3.34A4.91,4.91,0,0,0,251.9,220c-4.23,3.45-6.37,11-8.09,17.06l-.49,1.73a133.57,133.57,0,0,0-4.13,21",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.37,261.55a139.12,139.12,0,0,1,4.79-17.38c2.38-6.79,7.74-17,4.26-24-2.85-5.73-10.31-7.86-15.4-3.7-5.82,4.74-8.13,14.25-10.09,21.06a137.78,137.78,0,0,0-4.07,20",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.35,260.17a127.94,127.94,0,0,1,4.12-14.49c.39-1.13.89-2.39,1.42-3.74,2.84-7.23,6.38-16.24,2.61-23.82a15.15,15.15,0,0,0-13.42-8.4,14,14,0,0,0-8.94,3.19c-6.46,5.27-9,14.36-11.11,21.65l-.48,1.69a136.16,136.16,0,0,0-3.83,18.09",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.67,257.54c.93-3.66,1.95-7.05,3.1-10.35.38-1.07.85-2.28,1.35-3.55,3-7.68,7.13-18.16,2.46-27.54a19.71,19.71,0,0,0-17.5-10.94,18.48,18.48,0,0,0-11.82,4.22c-7.58,6.18-10.37,16-12.62,23.94l-.48,1.68a137.93,137.93,0,0,0-3.39,15.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.16,253.09c1-7.32,6.9-16,7.48-26.15.53-9.3-2.53-15.26-4.7-18.25a5.52,5.52,0,0,1-.64-5.12,19.74,19.74,0,0,0-.14-13.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.3,176.78C265,181.6,270,189.19,270.39,199c.13,3.52-2.73,4.73-6.31,3.64-7.49-2.28-25.34-8.12-36.22,22.47a117.4,117.4,0,0,0-4.6,19.47",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,177.28a29.44,29.44,0,0,1,13.83,3.24c7.31,3.93,11.91,13.17,9.56,15.52-2.61,2.61-7.46-3.69-22.29,2.39-7.13,2.92-12.19,8.87-15.63,15.63a67.1,67.1,0,0,0-3.92,9.58,116.41,116.41,0,0,0-3.4,12.9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.57,182.92a32.43,32.43,0,0,1,8-1.07c13.09-.3,18,6.68,16.56,8.45-1.21,1.49-3.9.65-7.59,1.1-10.65,1.31-19.07,7.37-24.74,16.33a65.22,65.22,0,0,0-6.64,14.48c-.3.91-.59,1.83-.87,2.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.4,190.45a23.14,23.14,0,0,1,15.46-5.12c1.66,0,5.76.54,6.31,2.11.73,2.06-5.93-.74-15.58,5.69-12.37,8.25-13.87,16.07-13.87,16.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.41,247.55s6.71-14.49,6-25.69c-.44-7.21-4-11.73-4.56-14.94s1-4,.58-6.94",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "196.04 179.34 196.04 158.88 216.5 158.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "216.5 279.88 196.04 279.88 196.04 259.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "304.77 179.34 304.77 158.88 284.31 158.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "284.31 279.88 304.77 279.88 304.77 259.42",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.68,468c-5.34-8-10.94-16.44-15.54-23.43l0,0c-5.88-8.91-10.12-15.42-10.12-15.42-2.25-10.53-5.44-14.66-8.65-23.31s-.56-16.36.77-27.07-.77-20.69-1.89-27.46.19-13.16,0-14.66-6.58-9.4-9-15.23a24.82,24.82,0,0,0-4.53-7.08,20.7,20.7,0,0,0-7.68-5.51,16.67,16.67,0,0,0-3.82-1c-3-.43-5.42.05-7.84.05-3.39,0-10.53-5.82-15.23-6.75a23.61,23.61,0,0,0-2.64-.37h0c-3.89-.37-8,0-12.55.36s-9.84-3.95-14.1-5.3l-.07,0a6.56,6.56,0,0,0-2.94-.32c-4.51.75-13,1.5-13,1.5s-.75-5.82-1.13-13.72c-.07-1.37-.17-2.69-.29-4v0c-.44-4.88-1.14-9.24-1.25-13.23,0-1,0-2.07,0-3.07.37-5.62.2-10,0-18.64,0-.29,0-.6,0-.91,0-2.69,0-5.26-.16-7.58a0,0,0,0,0,0,0c-.31-5.63-1.56-9.79-7.16-10.65-4.89-.75-8.27,1.69-10.34,9.78s-3.57,7.52-4.13,19.36-3.21,19.38-2.83,25.39-.94,17.67-.94,17.67c-2.25-1.13-4.32-.19-4.71.75s-2.05,10.16-3.38,16.74c-1.16,5.85-6.49,11.26-8.45,15.29l0,.09a8.84,8.84,0,0,0-.52,1.35c-1.13,4.14-.56,13-.56,24.26s-2.82,22.94,0,30.45a15.47,15.47,0,0,0,2.49,4.22c4.33,5.35,12.28,10,19.51,18.53,9,10.72,15.42,18.62,21.43,22.2,4.31,2.54,6.2,4.62,7,7.36v0a14.77,14.77,0,0,1,.49,3.64c.08,2.4,1.38,4.23,3.58,7.27a97.43,97.43,0,0,1,9,14.78c2.41,4.83,6.1,14,10,24.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.15,262.93c-.06,1-.07,2,0,3.07-7.19-1.36-21.07,2.19-21.28,6.43-.24,5.17-.87,17.39,1.76,20.24s8.27,4.67,8.27,4.67a12,12,0,0,0-1.24.16h0l-.14,0a9,9,0,0,0-4.7,2.64h0c-5.5,5.64-5.73,18.14-3.93,24.16,7.53,25-4.66,44.78-9,42.38s-4.69-23.89-3.38-28.92a33.37,33.37,0,0,0,1.15-9c-1.92-.64-5.95.29-9.65,1.44l0-.09c2-4,7.29-9.44,8.45-15.29,1.33-6.58,3-15.8,3.38-16.74s2.46-1.88,4.71-.75c0,0,1.32-11.65.94-17.67s2.26-13.54,2.83-25.39,2.06-11.27,4.13-19.36,5.45-10.53,10.34-9.78c5.6.86,6.85,5,7.16,10.65a19.66,19.66,0,0,0-2-1.66,8.91,8.91,0,0,0-6.23-1.84c-2.59.36-4.86,3-6.3,5.72h0c-2.07,4-2.41,8.29.5,6.82,3.3-1.65,10.11-1.1,14.26-.55C260.35,252.9,260.52,257.31,260.15,262.93Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.83,442.25a14.77,14.77,0,0,0-.49-3.64v0c-.79-2.74-2.68-4.82-7-7.36-6-3.58-12.41-11.48-21.43-22.2-7.23-8.57-15.18-13.18-19.51-18.53,5.45,2.95,12.85,1.43,15.18,6.1,3.39,6.74,19.31,17,19.31,17C269.43,429,267.83,442.25,267.83,442.25Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.7,295.78c-1.83-.37-6.79,11.86-7.26,16.2-1.25,11.25,4.52,45.93-2.9,45.15-3.07-.32-6.67-16.52-6.88-24.07-.67-22.93.25-32.46.25-32.46s-1.64-12.7-.54-21.35c.12,1.3.22,2.62.29,4,.38,7.9,1.13,13.72,1.13,13.72s8.46-.75,13-1.5A6.56,6.56,0,0,1,278.7,295.78Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.42,300.75c-4,.36-8,4.27-11.29,5-4,.85-11.35-8.16-15.36-9.92,4.26,1.35,9.6,5.59,14.1,5.3S301.53,300.38,305.42,300.75Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.17,307.82a31.47,31.47,0,0,0-4.73,8.21c-3.22,10.41-.18,49.8-5.37,43.35-6.76-8.38.3-37.45-4.63-48.55-1.56-3.55-7.13-9.23-8.34-9.71,4.7.93,11.84,6.75,15.23,6.75C325.75,307.87,328.18,307.39,331.17,307.82Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.12,444.56c-5.27-5.94-10.79-11.6-14.4-13.72-8.79-5.18-11.31-10.54-12.07-19.47s1.51-8.74,4.14-17.57-2.26-19.75-1.88-17.39-3.77,18.7-6.82,19.51-4.08-10.21-4.46-19.19,4.51-50.8,3.14-59a11.55,11.55,0,0,0-1.1-3.42,24.82,24.82,0,0,1,4.53,7.08c2.45,5.83,8.84,13.73,9,15.23s-1.13,7.9,0,14.66,3.2,16.73,1.89,27.46-4,18.42-.77,27.07,6.4,12.78,8.65,23.31C366,429.14,370.24,435.65,376.12,444.56Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.75,323c2,2.1,3.26,29.62,4.39,36.39s-2.38,23-4.39,18.06S288.61,314.44,296.75,323Z",
    style: {
      fill: "#10A7D0",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289,484.6c-3.32-8.58-6.39-16.09-8.49-20.3a97.43,97.43,0,0,0-9-14.78c-2.2-3-3.5-4.87-3.58-7.27a14.77,14.77,0,0,0-.49-3.64v0c-.79-2.74-2.68-4.82-7-7.36-6-3.58-12.41-11.48-21.43-22.2-7.23-8.57-15.18-13.18-19.51-18.53a15.47,15.47,0,0,1-2.49-4.22c-2.82-7.51,0-19.18,0-30.45s-.57-20.12.56-24.26a8.84,8.84,0,0,1,.52-1.35l0-.09c2-4,7.29-9.44,8.45-15.29,1.33-6.58,3-15.8,3.38-16.74s2.46-1.88,4.71-.75c0,0,1.32-11.65.94-17.67s2.26-13.54,2.83-25.39,2.06-11.27,4.13-19.36,5.45-10.53,10.34-9.78c5.6.86,6.85,5,7.16,10.65a0,0,0,0,1,0,0c.13,2.32.11,4.89.16,7.58,0,.31,0,.62,0,.91.18,8.61.35,13,0,18.64-.06,1-.07,2,0,3.07.11,4,.81,8.35,1.25,13.23v0c.12,1.3.22,2.62.29,4,.38,7.9,1.13,13.72,1.13,13.72s8.46-.75,13-1.5a6.56,6.56,0,0,1,2.94.32l.07,0c4.26,1.35,9.6,5.59,14.1,5.3s8.66-.73,12.55-.36h0a23.61,23.61,0,0,1,2.64.37c4.7.93,11.84,6.75,15.23,6.75,2.42,0,4.85-.48,7.84-.05a16.67,16.67,0,0,1,3.82,1,20.7,20.7,0,0,1,7.68,5.51,24.82,24.82,0,0,1,4.53,7.08c2.45,5.83,8.84,13.73,9,15.23s-1.13,7.9,0,14.66,3.2,16.73,1.89,27.46-4,18.42-.77,27.07,6.4,12.78,8.65,23.31c0,0,4.24,6.51,10.12,15.42l0,0c4.08,6.19,8.94,13.55,13.72,20.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.58,297.34c0,8.28-.75,18.55-2,22.82s-.41,18.55-2.71,24.56",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.85,303.86s5.76-6.52,10-6.52,8.53,2.76,13,3.26,9.21-2.83,13.54-3.63",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.1,273.69s7.78-2.84,11.79,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,270s2.38-.65,5.89,1.05",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,250a18.41,18.41,0,0,1,8,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,330.11s5-2.43,7-2.68",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.21,337.81s-3,4.66-3.56,6.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.92,229.66s-1.2,9.57,0,10.42,10.47,1.66,11.23,0,.89-8.67.89-8.67S252.49,221.88,245.92,229.66Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,314.83s7.69-3.88,7.87-9.43-2.08-5.49-4.94-5.52",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.39,327.43c.25,8.77-2.25,34.34-2.51,38.1s0,13.37,0,13.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.49,307.35c8.27,12,0,7.48,5.26,64.95",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366,429.14s-7.33-5.7-8.59-9",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.66,426.44c2.2,3.65,3.59,11.65,3.67,12.14v0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.1072146892547607px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.460864a35358a6aa0e496a237ec6236b.svg";
export { ForwardRef as ReactComponent };